let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("19M8q")).then(() => parcelRequire('14EEk'));